export interface TenantApiResource {
  id: string;
  code: string;
  name: string;
  type: string;
  business_name: string | null;
  default_language: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface Tenant {
  id: string;
  code: string;
  name: string;
  type: string;
  businessName: string | null;
  defaultLanguage: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface TenantListItemApiResource extends TenantApiResource {
  owner_name: string | null;
  owner_email: string | null;
  active_module_count: number;
}

export interface TenantListItem extends Tenant {
  ownerName: string | null;
  ownerEmail: string | null;
  activeModuleCount: number;
}

export function mapApiResourceToTenant(resource: TenantApiResource): Tenant {
  return {
    id: resource.id,
    code: resource.code,
    name: resource.name,
    type: resource.type,
    businessName: resource.business_name,
    defaultLanguage: resource.default_language,
    status: resource.status,
    createdAt: resource.created_at,
    updatedAt: resource.updated_at,
  };
}

export function mapApiResourceToTenantListItem(
  resource: TenantListItemApiResource
): TenantListItem {
  return {
    ...mapApiResourceToTenant(resource),
    ownerName: resource.owner_name,
    ownerEmail: resource.owner_email,
    activeModuleCount: resource.active_module_count,
  };
}

export interface TenantDetailApiResource extends TenantApiResource {
  owner_name: string | null;
  owner_email: string | null;
  active_module_count: number;
  member_count: number;
}

export interface TenantDetail extends Tenant {
  ownerName: string | null;
  ownerEmail: string | null;
  activeModuleCount: number;
  memberCount: number;
}

export function mapApiResourceToTenantDetail(resource: TenantDetailApiResource): TenantDetail {
  return {
    ...mapApiResourceToTenant(resource),
    ownerName: resource.owner_name,
    ownerEmail: resource.owner_email,
    activeModuleCount: resource.active_module_count,
    memberCount: resource.member_count,
  };
}

export interface TenantMemberApiResource {
  user_id: string;
  full_name: string;
  email: string;
  role_code: string;
  scope_code: string;
  is_owner: boolean;
}

export interface TenantMember {
  userId: string;
  fullName: string;
  email: string;
  roleCode: string;
  scopeCode: string;
  isOwner: boolean;
}

export function mapApiResourceToTenantMember(resource: TenantMemberApiResource): TenantMember {
  return {
    userId: resource.user_id,
    fullName: resource.full_name,
    email: resource.email,
    roleCode: resource.role_code,
    scopeCode: resource.scope_code,
    isOwner: resource.is_owner,
  };
}
